import {
  doiDefinition,
  issnDefinition,
  isbnDefinition,
  landingPageUrlDefinition,
  publisherDefinition,
  referencesDefinition,
  languageCodesDefinition,
  contributorDefinition,
  contributorsDefinition,
  abstractsDefinition,
  publicationDatesDefinition,
} from '../common/common-schemas';

const reportIsbnDefinition = {
  ...isbnDefinition,
  i18n: 'report_isbn',
  properties: {
    electronicIsbn: {
      ...isbnDefinition.properties.electronicIsbn,
      i18n: 'report_electronicIsbn',
    },
    printIsbn: {
      ...isbnDefinition.properties.printIsbn,
      i18n: 'report_printIsbn',
    },
  },
};

const commonDefinitions = {
  abstracts: abstractsDefinition,
  contributor: contributorDefinition,
  contributors: contributorsDefinition,
  doi: doiDefinition,
  isbn: isbnDefinition,
  'crossref_language_codes': languageCodesDefinition,
  issn: issnDefinition,
  landingPageUrl: landingPageUrlDefinition,
  publicationDates: publicationDatesDefinition,
  publisher: publisherDefinition,
  references: referencesDefinition,
};

export const reportSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Report Metadata',
  type: 'object',
  required: [
    'reportTitle',
    'doi',
    'landingPageUrl',
    'contributors',
    'publicationDates',
  ],
  properties: {
    reportTitle: {
      type: 'string',
      i18n: 'report_title',
    },
    doi: {
      ...doiDefinition,
      i18n: 'report_doi',
    },
    landingPageUrl: {
      ...landingPageUrlDefinition,
      i18n: 'report_landingPageUrl',
    },
    contributors: {
      $ref: '#/definitions/contributors',
    },
    abstracts: {
      $ref: '#/definitions/abstracts',
    },
    publisher: {
      ...publisherDefinition,
      i18n: 'report_publisher',
    },
    issuingInstitution: {
      type: 'object',
      i18n: 'report_issuingInstitution',
      properties: {
        institution: {
          type: 'string',
          i18n: 'report_issuingInstitution_institution',
          'x-rorIdField': 'rorId',
        },
        rorId: {
          type: 'string',
          i18n: 'report_issuingInstitution_rorId',
        },
      },
    },
    reportNumber: {
      type: 'string',
      i18n: 'report_reportNumber',
    },
    editionNumber: {
      type: 'integer',
      i18n: 'report_editionNumber',
    },
    publicationDates: {
      $ref: '#/definitions/publicationDates',
    },
    isbn: reportIsbnDefinition,
    references: {
      $ref: '#/definitions/references',
    },
  },
  definitions: {
    ...commonDefinitions,
  },
};

export const reportSeriesSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Report Series Metadata',
  type: 'object',
  required: ['seriesTitle', 'issn'],
  properties: {
    seriesTitle: {
      type: 'string',
      i18n: 'report_series_title',
    },
    issn: {
      ...issnDefinition,
      i18n: 'report_series_issn',
    },
  },
  definitions: {
    ...commonDefinitions,
  },
};

export const reportRecordSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Report',
  type: 'object',
  required: ['reportMetadata'],
  properties: {
    reportMetadata: reportSchema,
    series: reportSeriesSchema,
  },
  definitions: {
    ...commonDefinitions,
  },
};
